(function () {
  const RESET_DELAY_MS = 2000;

  function initDownloadsV2Copy(section) {
    for (const block of section.querySelectorAll('.downloads-v2_code')) {
      const textEl = block.querySelector('[data-downloads-v2-copy-text]');
      const button = block.querySelector('[data-downloads-v2-copy-button]');
      const icon = block.querySelector('[data-downloads-v2-copy-icon]');

      if (!textEl || !button || !icon) continue;

      const copyIconSrc = button.dataset.copyIcon;
      const checkIconSrc = button.dataset.checkIcon;
      let resetTimer;

      button.addEventListener('click', async () => {
        const text = textEl.textContent.trim();

        if (!text) return;

        try {
          await navigator.clipboard.writeText(text);
        } catch {
          return;
        }

        icon.src = checkIconSrc;
        button.setAttribute('aria-label', 'Copied');

        clearTimeout(resetTimer);
        resetTimer = window.setTimeout(() => {
          icon.src = copyIconSrc;
          button.setAttribute('aria-label', 'Copy to clipboard');
        }, RESET_DELAY_MS);
      });
    }
  }

  function initAll() {
    for (const section of document.querySelectorAll('.section-downloads-v2')) {
      initDownloadsV2Copy(section);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
